import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	errorStateHeading: {
		id: 'navigation.global-invite.error-state-heading',
		description:
			"Heading of the error state UI indicating we couldn't load the invite people widget.",
		defaultMessage: "We can't load the invite list right now",
	},
	errorStateDescription: {
		id: 'navigation.global-invite.error-state-description',
		description:
			"Description of the error state UI indicating we couldn't load the invite people widget.",
		defaultMessage: 'Try refreshing the page or contact us if the problem persists.',
	},
});
